// extracted by mini-css-extract-plugin
module.exports = {"modalSpinner":"az_hr","dialog":"az_ir"};